import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { debounce } from '@/modules/core/decorators/debounce';

@Component
export default class BaseTable extends Vue {
  @Prop({
    default: false,
  })
  public checkable!: boolean;

  @Prop({
    default: () => [],
  })
  public checkedRows!: any[];

  @Prop({
    default: false,
  })
  public useLocalData!: boolean;

  @Prop({
    default: () => [],
  })
  public localData: any;

  @Prop({
    default: true,
  })
  public showActions!: boolean;

  public pagination = {
    page: 1,
    limit: 15,
    total: 0,
  };

  public filters: any = null;

  public sortingPriority: any[] = [];

  public multiFilterCustomKey: string | null = null;

  public fetchedData = [];

  public isModalActive = false;
  public trashObject = null;
  public isLoading = false;
  public gridFilters = {};

  get rows(): any[] {
    if (this.localData && this.localData.length > 0) {
      this.pagination.total = this.localData.length;
      return this.localData;
    } else {
      return this.fetchedData;
    }
  }

  get sort(): any[] {
    return this.sortingPriority.map((sortItem: any) => `${sortItem.field}:${sortItem.order}`);
  }

  public async fetchData(): Promise<any> {
    throw new Error('To implement');
  }

  public async getData(): Promise<any> {
    if (this.useLocalData) {
      return;
    }
    this.isLoading = true;

    try {
      const fetchResult = await this.fetchData();

      if (fetchResult.items) {
        this.fetchedData = fetchResult.items;
        this.pagination.total = fetchResult.total;
      } else {
        this.fetchedData = fetchResult;
        this.pagination.total = fetchResult.length;
      }

    } catch (_) {
      console.error('ERROR FETCHING DATA', _);
    }
    this.isLoading = false;
  }

  public mounted(): void {
    this.buildFilters(this.gridFilters);
    this.$emit('filter-change', this.filters);
    this.$emit('sort-change', this.sort);
  }

  public buildFilters(gridFilters: any): void {
    this.gridFilters = gridFilters;
    this.filters = {...this.filters, ...gridFilters};
  }

  public onPageChange(page: number): void {
    this.pagination.page = page;
    this.getData();
  }

  @debounce(300)
  public onFiltersChange(gridFilters: any): void {
    this.gridFilters = gridFilters;
    this.buildFilters(this.gridFilters);
  }

  public onSortingPriorityRemoved(field: string): void {
    this.sortingPriority = this.sortingPriority.filter(
      (priority: any) => priority.field !== field,
    );
    this.$emit('sort-change', this.sort);
    this.getData();
  }

  public onSortChange(field: string, order: string, event: any): void {
    if (
      (this.multiFilterCustomKey && event[this.multiFilterCustomKey]) ||
      !this.multiFilterCustomKey
    ) {
      const existingPriority: any = this.sortingPriority.find(
        (i: any) => i.field === field,
      );
      if (existingPriority) {
        existingPriority.order =
          existingPriority.order === 'desc' ? 'asc' : 'desc';
      } else {
        this.sortingPriority.push({ field, order });
      }
    } else {
      // request regular sorted data from backend
      this.sortingPriority = []; // [{field, order}]
      // this.loadAsyncData([{ field, order }]);
    }

    this.$emit('sort-change', this.sort);
    this.getData();
  }

  public onEntityDeleted(): void {
    this.getData();
  }

  @Watch('filters', { deep: true })
  public onAllFilersChange(): void {
    this.$emit('filter-change', this.filters);
    this.getData();
  }

  //   trashModal(trashObject) {
  //     this.trashObject = trashObject;
  //     this.isModalActive = true;
  //   }

  //   async trashConfirm() {
  //     this.isModalActive = false;
  //     await agencyApi.remove(this.trashObject.id);
  //     this.$buefy.snackbar.open({
  //       message: `${this.trashObjectName} supprimée`,
  //       queue: false,
  //     });

  //     await this.getAgencies();
  //   }

  //   trashCancel() {
  //     this.isModalActive = false;
  //   }
}
